import { PageHeader } from '@/components/core';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui-kit/tabs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GeneralInfo } from '../../components/general-info/general-info';
import { HrInfo } from '../../components/hr-info/hr-info';

export const ProfilePage = () => {
  // A page that links back here (Edit profile's back button) can name the tab to open.
  const location = useLocation();
  const [tabId, setTabId] = useState(
    (location.state as { tab?: string } | null)?.tab ?? 'generalInfo'
  );
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title={t('MY_PROFILE')} />

      {/* onValueChange (not just each trigger's onClick) so Radix's own keyboard/arrow-key tab
          navigation also updates `tabId`, instead of only working for mouse clicks. */}
      <Tabs value={tabId} onValueChange={setTabId}>
        {/* Full width on a phone, each tab an equal share. */}
        <div className="mb-3 flex items-center rounded text-base sm:mb-5">
          <TabsList className="max-sm:w-full max-sm:justify-start max-sm:overflow-x-auto">
            <TabsTrigger
              onClick={() => setTabId('generalInfo')}
              value="generalInfo"
              className="max-sm:flex-1"
            >
              {t('GENERAL_INFO')}
            </TabsTrigger>
            <TabsTrigger
              onClick={() => setTabId('hrInfo')}
              value="hrInfo"
              className="max-sm:flex-1"
            >
              {t('USER_INFO')}
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="generalInfo">
          <GeneralInfo />
        </TabsContent>

        <TabsContent value="hrInfo">
          <HrInfo />
        </TabsContent>
      </Tabs>
    </div>
  );
};
